export default "__VITE_PUBLIC_ASSET__19b23717__"